/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// For product page quantity box
/*jQuery(document).ready(function () {
  jQuery('.increase-picker-quantity').on('click',function(){
      jQuery(".quantity-selector__value").val(Number(jQuery(".quantity-selector__value").val())+1); 
  });
  jQuery('.decrease-picker-quantity').on('click',function(){
      if(jQuery(".quantity-selector__value").val()>1)
      jQuery(".quantity-selector__value").val(Number(jQuery(".quantity-selector__value").val())-1);
  });
});*/
// End product page quantity box

// jQuery(document).ready(function() {
//     jQuery('.mobile-menu__nav').each(function() {
//         var menuItemName = jQuery(this).find('.mobile-menu__nav-item').text().trim();
//         console.log(menuItemName);
//         if (menuItemName === 'Locations' || menuItemName === 'Financing' || menuItemName === 'Latest Flyer') {
//             jQuery(this).closest('li').addClass('mob-class');
//         }
//     });
// });
//// home page slide///
  jQuery(".two-imgbar-slick-slider").slick({
     slidesToShow: 1,
     infinite:true,
     slidesToScroll: 1,
     autoplay: false,
     autoplaySpeed: 2000
  });
//// home page slide end///

let checkExist = setInterval(function() {
  let $variantSwatchLists = jQuery(".coll-swatch-list-element .product-form__variants .variant-swatch-list");

  if ($variantSwatchLists.length > 0) {
    $variantSwatchLists.each(function() {
      let $this = jQuery(this);
      if ($this.children().length > 3 && !$this.hasClass('slick-initialized')) {
        $this.slick({
          slidesToShow: 3,
          infinite: true,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
          dots: true,
          arrows: false
        });
      }
    });

    clearInterval(checkExist);
  }
}, 500);


jQuery(".two-imgbar-main-slider").slick({
  slidesToShow: 2,
  infinite: true,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1001,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

jQuery(document).ready(function() {
    jQuery(".slider").on("input", function() {
        var $this = jQuery(this);
        var $minInput = $this.parent().find(".min-value");
        var $maxInput = $this.parent().find(".max-value");

        if ($this.hasClass("min-slider")) {
            $minInput.val($this.val());
        } else {
            $maxInput.val($this.val());
        }
    });
    jQuery(".min-value, .max-value").on("input", function() {
        var $this = jQuery(this);
        var $slider = $this.parent().find(".slider");

        $slider.val($this.val());
    });
});


// Product details page 3 buttons wrap Wishlist, compare, find a store
/*jQuery(document).ready(function() { 
  setTimeout(function () {
    jQuery("#wishlisthero-product-page-button-container").prependTo(".wishlist-block-cls");
  }, 600);
});*/
// End Product details page 3 buttons wrap Wishlist, compare, find a store

// Adding to prevent issue from weaver link
// if (!api_link) {
//   console.warn("No API link found");
//   processData([]);
//   return;
// }

jQuery(document).ajaxComplete(function(event, request, settings){
      processTagData();
       updateFilterState();
});

// new code start tag for app
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  //d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  d.setTime(d.getTime() + (30 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function processTagData() {
  var tagData = getCookie("tagData");
  var dataArray;
  var api_link= jQuery(".store-id").attr('data-storename');
  
  if (tagData != "") {
    dataArray = JSON.parse(tagData);
    processData(dataArray);
    
  } else {
  
    jQuery.ajax({
      url: api_link,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
      success: function(result) {
        dataArray = JSON.parse(result);
        const myJSON = JSON.stringify(dataArray);
        setCookie('tagData', myJSON, 1);
        console.log(dataArray);
        processData(dataArray);
      },
      error: function(error) {
        console.error(error);
        // Handle the error (e.g., show a message or fallback behavior)...
      },
    });
  }
}
function processData(dataArray) {
      
    jQuery(".tag-items").each(function () {
      var prod_tag_array = jQuery(this).data("tag_name").split(",");
      var prod_id = jQuery(this).data("item-id");

      var images = [];
      var printedCount = 0;
      jQuery.each(prod_tag_array, function (index, value) {
        jQuery.each(dataArray, function (key, item) {
           if (printedCount < 2 && item.Tile == value) {
           images.push('<div class="tag-item"><img src="' + item.TagImage + '"></div>'); // Add image to the array
          }
           
        });
      });

      jQuery('.tagnamedisplay-' + prod_id).html(images.join("")); // Display all images for this product ID
    });
}




jQuery(document).ready(function () {
    jQuery('#new-deal-top').click(function(){
        jQuery('.switch-checkbox').trigger('click');
    });
});


jQuery(window).on('load', function() {
  // Your code here
  var $window = jQuery(window);
  var nav = jQuery('.qsc2-stickybar--desktop-bottom.qsc2-stickybar--mobile-bottom');

  if (nav.length && $window.length) {
    nav.hide();
    var prev = $window.scrollTop();

    $window.on('scroll', function(){
      var scrollTop = $window.scrollTop();
      if (scrollTop > 600) {
        // Scrolling down
        nav.fadeIn();
      } else {
        // Scrolling to the top
        nav.fadeOut();
      }
      //prev = scrollTop;
    });
  }
});




// end new code start tag for app

// Footer toggle menu disabled attribute remove
jQuery(document).ready(function () {
  setTimeout(function () {
    jQuery(".footer__title").prop("disabled", false); // Element(s) are now enabled.
  }, 5000);
});
// End Footer toggle menu disabled attribute remove

// Product details page tab active and scroll up
jQuery(document).ready(function () {
  setTimeout(function () {
    jQuery("button.nav-link").click(function () {
      //console.log("10000");
      if (jQuery("button.nav-link").hasClass("active")) {
        //console.log("testeeeeee");
        var target = jQuery(".accordion-body");
        if (target.length) {
          jQuery("html,body").animate(
            {
              scrollTop: target.offset().top - 250,
            },
            1000
          );
          return false;
        }
      }
    });
  }, 3000);
});
// End Product details page tab active and scroll up

// Product list page quick view icon

jQuery(document).ready(function () {
  jQuery(".quickview-icon").click(function () {});
});
// End qyuick view icon

// Product tab popup
jQuery(document).ready(function () {
  jQuery("#popup-btn0").click(function () {
    //alert("ok");
    jQuery("#popup-wrapper0").toggleClass("show-tab");
    jQuery("#popup-btn0").toggleClass("active-tab-cls");
    jQuery("html").toggleClass("htmlmobcls");
  });

  jQuery("#popup-btn1").click(function () {
    //alert("ok");
    jQuery("#popup-wrapper1").toggleClass("show-tab");
    jQuery("#popup-btn1").toggleClass("active-tab-cls");
    jQuery("html").toggleClass("htmlmobcls");
  });

  jQuery("#popup-btn2").click(function () {
    //alert("ok");
    jQuery("#popup-wrapper2").toggleClass("show-tab");
    jQuery("#popup-btn2").toggleClass("active-tab-cls");
    jQuery("html").toggleClass("htmlmobcls");
  });

  jQuery("#popup-btn3").click(function () {
    //alert("ok");
    jQuery("#popup-wrapper3").toggleClass("show-tab");
    jQuery("#popup-btn3").toggleClass("active-tab-cls");
    jQuery("html").toggleClass("htmlmobcls");
  });

  jQuery("#popup-btn4").click(function () {
    //alert("ok");
    jQuery("#popup-wrapper4").toggleClass("show-tab");
    jQuery("#popup-btn4").toggleClass("active-tab-cls");
    jQuery("html").toggleClass("htmlmobcls");
  });

  jQuery(".close-tab").click(function () {
    jQuery("#popup-wrapper0").removeClass("show-tab");
    jQuery("#popup-wrapper1").removeClass("show-tab");
    jQuery("#popup-wrapper2").removeClass("show-tab");
    jQuery("#popup-wrapper3").removeClass("show-tab");
    jQuery("#popup-wrapper4").removeClass("show-tab");
    jQuery("html").removeClass("htmlmobcls");

    jQuery("#popup-btn0").removeClass("active-tab-cls");
    jQuery("#popup-btn1").removeClass("active-tab-cls");
    jQuery("#popup-btn2").removeClass("active-tab-cls");
    jQuery("#popup-btn3").removeClass("active-tab-cls");
    jQuery("#popup-btn4").removeClass("active-tab-cls");

    // Scroll to same position in mobile view
    if (jQuery("button.nav-link").hasClass("active")) {
      //console.log("testeeeeee");
      var target = jQuery(".accordion-body");
      if (target.length) {
        jQuery("html,body").animate(
          {
            scrollTop: target.offset().top - 250,
          },
          //1000
          100
        );
        return false;
      }
    }
    // End Scroll to same position in mobile view
  });
});
// End product tab popup

jQuery(document).ready(function () {
  jQuery(".slick-slider").slick({
    infinite: true,
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    slidesToShow: 6,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1601,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1301,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1101,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 801,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 549,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  jQuery(".sublist-carousel").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });


  var elem = document.querySelector('.carousel-shoplist');
  var flkty = new Flickity(elem, {
    // options
    // initialIndex: 4,
    // pageDots: false,
    // //contain: true,
    // //accessibility: true,
    // autoPlay: 1500,
    // freeScroll: true,
    // wrapAround: true,
    // freeScroll: true
  });

  // Page collection loadin issue resolve
  var numImgs = jQuery('div .shop-product-wrap img').length; 
  //alert(numImgs);
  if (numImgs > 0) {
        console.log('Data has been loaded successfully');
      //alert('Data has been loaded successfully');
      jQuery('.custom-lazy-load').hide();
      //jQuery('.shop-product-wrap').show();
      jQuery('.shop-product-wrap').css("visibility", "visible");
    } else {
        console.log('No data loaded');
      //alert('No data loaded');
    }
  // End Page collection loadin issue resolve
  
  
 });


// Page collection loadin issue resolve
/*jQuery('.carousel-shoplist').on('init', function(event, slick) {
    let slideCount = slick.slideCount;
    console.log('Slide count:', slideCount);
    if (slideCount > 0) {
        console.log('Data has been loaded successfully');
      //alert('Data has been loaded successfully');
      jQuery('.custom-lazy-load').hide();
      jQuery('.shop-product-wrap').show();
    } else {
        console.log('No data loaded');
      //alert('No data loaded');
    }
});*/
// End Page collection loadin issue resolve


jQuery(document).ready(function () {
  jQuery(".load-morewrap #showLess").css("display", "none");
  size_li = jQuery("#loadmorenews .morenews").length;
  x = 8;
  if (size_li > 8) {
    jQuery(".load-morewrap").show();
  } else {
    jQuery(".load-morewrap").hide();
  }
  jQuery("#loadmorenews .morenews").hide();

  jQuery("#loadmorenews .morenews:lt(" + x + ")").show();
  jQuery("#loadMore").click(function (e) {
    e.preventDefault();
    x = x + 4 <= size_li ? x + 4 : size_li;
    jQuery("#loadmorenews .morenews:lt(" + x + ")").show();
    if (jQuery("#loadmorenews .morenews:hidden").length == 0) {
      jQuery(this).hide();
      jQuery(".load-morewrap #showLess").css("display", "inline-block");
    }
  });
  jQuery("#showLess").click(function () {
    event.preventDefault();
    //x = x - 4 < 8 ? 8 : x - 4;
    x = x - 4 < size_li ? 8 : x - 4;
    //alert(x);
    jQuery("#loadmorenews .morenews")
      .not(":lt(" + x + ")")
      .hide();
    jQuery(".load-morewrap #showLess").css("display", "none");
    jQuery(".load-morewrap #loadMore").css("display", "inline-block");
  });
});
jQuery(document).ready(function (event) {
  if (
    jQuery(".collectionlist-block")[0] ||
    jQuery(".shopby-brand-section")[0]
  ) {
    //
  } else {
    // Do something if class does not exist
    jQuery("body").addClass("active_collection");
    // alert('hii');
  }
});
jQuery(document).ready(function () {
  setTimeout(function () {
    //alert("ok");
    // Get the current action attribute value
    var currentAction = jQuery("#myForm").attr("action");
    // Remove the desired string (e.g., 'remove-me')
    var newAction = currentAction.replace("/a", "");
    //alert(newAction);
    // Update the form's action attribute with the modified URL
    jQuery("#myForm").attr("action", newAction);

    var currentActionBlank = jQuery(".empty-state__quick-form").attr("action");
    var newActionBlank = currentActionBlank.replace("/a", "");
    jQuery(".empty-state__quick-form").attr("action", newActionBlank);
  }, 2000);
});

// For Product details page tab
jQuery(document).ready(function () {
  jQuery("ul.nav-tabs li:first-child button").click();
});

jQuery(document).ready(function () {
  jQuery(".product-list-slick").slick({
    infinite: true,
    //speed: 3000,
    autoplay: false,
    autoplaySpeed: 0,
    slidesToShow: 4,
    slidesToScroll: 1,
    //variableWidth: true,
    arrows: true,
    //dots: false,
    //pauseOnHover: false,
    //cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1601,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1301,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1101,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 801,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 549,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

// For Product details page tab
jQuery(document).ready(function () {
  jQuery(".product-list-slick").slick("setPosition");
});

// For product deatils page related product
jQuery(".variable").slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

jQuery("#associates").find("img:not([alt])").attr("alt", "Alt text");

jQuery(document).ready(function () {
  jQuery("ul.main-item").css("display", "none");

  jQuery(".slick-slide").click(function () {
    jQuery("#selected-products-box").css("display", "block");
    jQuery("ul.main-item").css("display", "block");
  });
});

function updateSelectedProducts() {
  var selectedProductsList = document.getElementById("selected-products-list");
  var checkboxes = document.querySelectorAll(".associated-product__checkbox");
  selectedProductsList.innerHTML = ""; // clear existing list

  for (var i = 0; i < checkboxes.length; i++) {
    var checkbox = checkboxes[i];
    if (checkbox.checked) {
      var variantId = checkbox.getAttribute("data-variant");
      var imgSrc = checkbox.parentNode
        .querySelector(".associated-product__image")
        .getAttribute("src");
      var price_val = checkbox.parentNode.querySelector(
        ".associated-product__price"
      ).innerHTML;
      var price = parseFloat(price_val.replace("$", ""));
      var title = checkbox.parentNode.getAttribute("title");

      var listItem = document.createElement("div");
      listItem.className = "selected-product-item";
      listItem.innerHTML =
        "<img src='" +
        imgSrc +
        "' class='selected-product-img'>" +
        "<span class='selected-product-title'>" +
        title +
        "</span>" +
        "<div class='quantity-buttons'> " +
        "<button class='minus-btn' type='button' name='button'>-</button>" +
        "<input type='text' name='name' value='1'>" +
        "<button class='plus-btn' type='button' name='button'>+</button>" +
        "<button class='remove-btn' type='button' name='button'>Remove</button>" +
        "</div>" +
        "<span class='selected-product-price' data-price='" +
        price +
        "'>$" +
        price.toFixed(2) +
        "</span>";

      selectedProductsList.appendChild(listItem);
    }
  }

  var minusButtons = document.querySelectorAll(".minus-btn");
  for (var i = 0; i < minusButtons.length; i++) {
    minusButtons[i].addEventListener("click", function () {
      var inputField = this.parentNode.querySelector("input");
      var currentValue = parseInt(inputField.value);
      if (currentValue > 1) {
        inputField.value = currentValue - 1;

        // update selected product price based on new quantity
        var selectedProductPrice = this.parentNode.parentNode.querySelector(
          ".selected-product-price"
        );
        var price = parseFloat(selectedProductPrice.getAttribute("data-price"));
        var newPrice = (price / currentValue) * (currentValue - 1);
        selectedProductPrice.setAttribute("data-price", newPrice.toFixed(2)); // update data-price attribute
        selectedProductPrice.innerHTML = "$" + newPrice.toFixed(2);
      }
    });
  }

  var plusButtons = document.querySelectorAll(".plus-btn");
  for (var i = 0; i < plusButtons.length; i++) {
    plusButtons[i].addEventListener("click", function () {
      var inputField = this.parentNode.querySelector("input");
      var currentValue = parseInt(inputField.value);
      inputField.value = currentValue + 1;

      // update selected product price based on new quantity
      var selectedProductPrice = this.parentNode.parentNode.querySelector(
        ".selected-product-price"
      );
      var price = parseFloat(selectedProductPrice.getAttribute("data-price"));
      var newPrice = (price / currentValue) * (currentValue + 1);
      selectedProductPrice.setAttribute("data-price", newPrice.toFixed(2)); // update data-price attribute
      selectedProductPrice.innerHTML = "$" + newPrice.toFixed(2);
    });
  }

  var removeButtons = document.querySelectorAll(".remove-btn");
  for (var i = 0; i < removeButtons.length; i++) {
    removeButtons[i].addEventListener("click", function () {
      this.parentNode.parentNode.remove();
    });
  }
}

function callClearFunc() {
  console.log("called cleared");

  document.getElementById("deselectAll").style.display = "block";

  // Get all checkboxes
  const checkboxes = document.querySelectorAll(
    ".associated-product__checkbox-2"
  );

  // Add click event listener to each checkbox
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener("click", function () {
      console.log("addEventListener cleared");
      const deselectAllButton = document.getElementById("deselectAll");
      deselectAllButton.style.display = "block";
    });
  });

  // Add click event listener to "Deselect All" button
  const deselectAllButton = document.getElementById("deselectAll");
  const deselectBottomBoxes = document.getElementById("selected-products-box");

  deselectAllButton.addEventListener("click", function () {
    checkboxes.forEach(function (checkbox) {
      checkbox.checked = false;
    });
    deselectAllButton.style.display = "none";
    deselectBottomBoxes.style.display = "none";
  });

  // Add click event listener to "Select All" button
  const selectAllButton = document.getElementById("selectAll");
  selectAllButton.addEventListener("click", function () {
    checkboxes.forEach(function (checkbox) {
      checkbox.checked = true;
    });
    deselectAllButton.style.display = "block";
  });
}

// event listener for associated product checkboxes
var checkboxes = document.querySelectorAll(".associated-product__checkbox");
for (var i = 0; i < checkboxes.length; i++) {
  checkboxes[i].addEventListener("change", function () {
    updateSelectedProducts();
    callClearFunc();
  });
}

// When a related item is clicked, display its details below it
const relatedItemLinks = document.querySelectorAll(".related-item-link");
relatedItemLinks.forEach((link) => {
  link.addEventListener("click", () => {
    const itemDetails = link.nextElementSibling;
    itemDetails.classList.toggle("active");
  });
});

// Promo code

jQuery(".pro-detail-btn").click(function () {
  if (jQuery(".promo-section-wraper").hasClass("arrowup")) {
    jQuery(".promo-section-wraper")
      .addClass("arrowdown")
      .removeClass("arrowup");
  } else {
    jQuery(".promo-section-wraper")
      .addClass("arrowup")
      .removeClass("arrowdown");
  }

  jQuery(this).text(function (i, v) {
    return v == "Show all offers" ? "Hide all offers" : "Show all offers";
  });
  jQuery(".promo-details").toggle();
  jQuery("#pdp_sidebar_overlay").toggle();
});

// End promo code

// Addon Products dropdown code
jQuery(document).ready(function () {
  setTimeout(function () {
    //jQuery(".spice-spa-addon-product-wrapper").hide();
    jQuery(".spice-spa-addon-heading").click(function () {
      jQuery(this).toggleClass("spa-addon-highlight-arrow");
      jQuery(".spice-spa-addon-product-wrapper").toggleClass(
        "spa-addon-highlight"
      );
    });
  }, 3000);
});
// End Addon products dropdown end
// Add To cart
jQuery(document).ready(function () {
  //var addToCartBtn = document.getElementsByClassName("addtocart");
  var productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener("submit", function (e) {
      e.preventDefault();

      // Check if some associated products are checked
      var checkboxes = document.getElementsByClassName(
        "associated-product__checkbox"
      );
      var associatedProducts = [];

      for (checkbox of checkboxes) {
        if (checkbox.checked) {
          var productToAdd = {
            id: checkbox.getAttribute("data-variant"),
            quantity: "1",
          };
          associatedProducts.push(productToAdd);
        }
      }

      let formData = new FormData(productForm);
      var products = [
        ...associatedProducts,
        { id: formData.get("id"), quantity: formData.get("quantity") },
      ];
      fetch("/cart/add.js", {
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: products }),
        method: "POST",
      })
        .then((response) => {
          location.href = "/cart";
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  }
});

// Rebates message display in model popup

function rebatesclick() {
  //alert("yyy");
  //alert("ok");
  var tiers = jQuery("#bmsm-tiers").toggleClass("display-tiers");
  var button = jQuery("#pdp-banner-button").text();
  //alert(jQuery("#pdp-banner-button").attr('data-state'));
  if (jQuery("#pdp-banner-button").attr("data-state") == "closed") {
    jQuery("#pdp-banner-button").html(
      '<p>HIDE SAVINGS</p><i class="fa-solid fa-angle-up"></i>'
    );
    jQuery(".pdp-banner-button").attr("data-state", "open");
  } else {
    jQuery("#pdp-banner-button").html(
      '<p>VIEW SAVINGS</p><i class="fa-solid fa-angle-down"></i>'
    );
    jQuery(".pdp-banner-button").attr("data-state", "closed");
  }
}
// End rebates model popup
 function updateFilterState() {
      //alert('hii');
        if (jQuery('.switch-checkbox').is(':checked')) {
            jQuery('.new-deal-filter').prop('checked', true);
        } else {
            jQuery('.new-deal-filter').prop('checked', false);
            // Uncheck the checkbox directly
            jQuery('#filter\\.p\\.m\\.custom\\.today_deals').prop('checked', false);
        }
    }

// For Frequently Bought With:
jQuery(document).ready(function () {
  setTimeout(function () {
  jQuery(".dynamic_title_upsell").on("click",function(e) {
    //alert("ok");
      e.stopPropagation();
      var clickedLi = jQuery(this);
      clickedLi.toggleClass("current");
      var $ul = jQuery("#launchtip_upsell_select_wrapper").find('ul');
      $ul.slideToggle();
    });
    }, 6000);
});


// Syndigo
const syndigoSection = document.querySelector('syndigo-powerpage')
const featuresSections = document.getElementById('product-features-section');
syndigoSection.addEventListener('content', function (ev) {
    if (!ev.detail.hasContent) {
      featuresSections.style.display = "block";
    }
})
